module.exports = __webpack_public_path__ + "static/media/astronaut.b867797a.png";